import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/shared/services/user.service';
import { AuthService } from '../../auth.service';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html'
})
export class PasswordComponent implements OnInit, OnDestroy {

  email: string;


  resetPasswordSubscription: Subscription;
  resetPasswordForm: FormGroup;

  constructor(
    private _user: UserService,
    private authService: AuthService,
    private alert: AlertService,
    private router: Router,
    private toastrService: ToastrService,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.createFormGroup();
  }

  createFormGroup() {
    this.resetPasswordForm = this.fb.group({
      email: [null, [Validators.required, Validators.email]]
    });
  }

  resetPassword() {

    this.resetPasswordSubscription = this.authService.remindPasswordSendEmail(this.resetPasswordForm.get('email').value).subscribe(response => {
      // this.alert.setMessage('Na Twój adres e-mail wysłaliśmy link do zmiany hasła.');
      this.toastrService.success('Na Twój adres e-mail wysłaliśmy link do zmiany hasła.');
      this.router.navigate(['/login']);

    },
      err => {
        // this.alert.setMessage('Adres e-mail nie widnieje w naszej bazie.');
        this.toastrService.error('Adres e-mail nie widnieje w naszej bazie.');
      }
    );

  }

  ngOnDestroy() {
    if (this.resetPasswordSubscription) {
      this.resetPasswordSubscription.unsubscribe();
    }
  }

}
